<template>
  <div class="v2-footer-copyright">
    <div class="container">
      <div class="row">
        <div class="col-6 col-lg-3 mb-2 owner_text">
          {{ ownerText }}
        </div>
        <div class="col-6 col-lg-3">
          <a href="/agb#notice">{{ t("18 U.S.C. 2257 Record-Keeping Requirements Compliance Statement ") }}</a>
        </div>
        <div class="col-6 col-lg-3">
          <footer-sales-partners-text />
        </div>
        <div class="col-6 col-lg-3">
          <a href="/agb#privacy_policy" class="d-block">{{ t("Data Protection Agreement") }}</a>
          <router-link v-if="!isIo" to="/sitemap" class="d-block">
            {{ t("Sitemap") }}
          </router-link>
          <template v-if="!hasAgeVerificationFeature">
            <a v-if="isIo" :href="blogUrl" class="d-block">{{ t("Blog") }}</a>
            <router-link v-else :to="blogUrl" class="d-block">
              {{ t("Blog") }}
            </router-link>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useCompanyStore } from "@/store/company";
import { useI18n } from "vue-i18n";
import { COMPANY_COMBINATOR, COMPANY_EEI } from "@/utils/variables";
import { getBlogUrl, getTld } from "@/utils/urlHelper";
import { useFeatureStore } from "@/store/feature.ts";
import FooterSalesPartnersText from "@/components/footer-sales-partners-text/index.vue";

defineOptions({
  name: "layout-footer-copyright",
});

const companyStore = useCompanyStore();
const featureStore = useFeatureStore();
const { t } = useI18n();

const isIo = getTld() === "io";

const hasAgeVerificationFeature = computed(() => featureStore.hasAgeVerificationFeature);

const ownerText = computed(() => {
  switch (companyStore.getCompany) {
    case COMPANY_COMBINATOR:
      return t("This site is operated by Combinator AG, Canton Schwyz, Switzerland");
    case COMPANY_EEI:
      return "EEI Solutions is a US Company in Tempe, AZ 85281, USA.";
    default:
      return t("This site is owned and operated by EFC GmbH, Canton Schwyz, Switzerland");
  }
});

const blogUrl = computed(() => (isIo ? `https://ersties.com${getBlogUrl()}` : getBlogUrl()));

companyStore.defineCompany(false);
</script>

<style lang="scss">
@import "./index";
</style>
